import {
  FetchBreakSettingsDocument,
  GetTimeSettingsBreakConfigurationsDocument,
  UpdateAttendanceBreakConfigurationDocument,
  UpdateAttendanceBreakConfigurationMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useUpdateAttendanceBreakConfiguration = () => {
  const [updateConfiguration, { loading }] = useMutation(
    UpdateAttendanceBreakConfigurationDocument,
    {
      extractorFn: (data) => data.attendanceMutations.updateAttendanceBreakConfiguration,
    }
  )

  const update = (variables: UpdateAttendanceBreakConfigurationMutationVariables) => {
    return updateConfiguration({
      variables,
      refetchQueries: [GetTimeSettingsBreakConfigurationsDocument, FetchBreakSettingsDocument],
    })
  }

  return {
    loading,
    update,
  }
}
